import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import injectSheet from 'react-jss';

import { FlagType } from '~/flags/flags';
import { withFlags } from '~/flags/withFlags';

import withFocus from '../../../Shared/HOCs/withFocus/withFocus';
import withHover from '../../../Shared/HOCs/withHover/withHover';
import ChevronDownIcon from '../../../Shared/Icons/ChevronDownIcon';
import { DocumentsViewPageConsumer } from '../../DocumentsViewPage.context';
import InformationField from '../InformationField/InformationField';
import { InformationFieldV2 } from '../InformationField/InformationFieldV2';
import styles from './KeyInformationSection.styles';

const InformationFieldWithHover = withFocus(withHover(InformationField));

class KeyInformationSection extends Component {
  constructor(props) {
    super(props);

    this.handleOnTitleClick = this.handleOnTitleClick.bind(this);
    this.state = { expanded: true };
    const { flags } = this.props;
    this.refactoredInformationFieldFlag =
      flags[FlagType.RefactoredInformationField];
  }

  componentDidMount() {
    this.setState({ section: this.props.section });
    this.props.onRef(this);
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  handleOnTitleClick() {
    this.setState({ expanded: !this.state.expanded });
  }

  expandSection() {
    this.setState({ expanded: true });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.section !== prevState.section) {
      return { section: nextProps.section };
    } else {
      return null;
    }
  }

  renderSectionFields() {
    const {
      showOCR,
      showFlaggedOnly,
      userVisibilityLevel,
      isTerminated,
      onFieldTokenClick,
      isPdfHighlighter,
    } = this.props;
    const { section } = this.state;
    let fields = section.fields.filter((field) => {
      if (showFlaggedOnly) return field.is_flagged;
      return field;
    });
    if (this.refactoredInformationFieldFlag) {
      fields = fields.map((field) => (
        <DocumentsViewPageConsumer key={field.id}>
          {(context) => (
            <InformationFieldV2
              key={field.id}
              field={field}
              showOCR={showOCR}
              userVisibilityLevel={userVisibilityLevel}
              isTerminated={isTerminated}
              documentId={context.document.id}
              refreshField={context.refreshField}
              onFieldTokenClick={onFieldTokenClick}
              isPdfHighlighter={isPdfHighlighter}
            />
          )}
        </DocumentsViewPageConsumer>
      ));
    } else {
      fields = fields.map((field) => (
        <DocumentsViewPageConsumer key={field.id}>
          {(context) => (
            <InformationFieldWithHover
              key={field.id}
              field={field}
              showOCR={showOCR}
              userVisibilityLevel={userVisibilityLevel}
              isTerminated={isTerminated}
              documentId={context.document.id}
              refreshField={context.refreshField}
              onFieldTokenClick={onFieldTokenClick}
              isPdfHighlighter={isPdfHighlighter}
            />
          )}
        </DocumentsViewPageConsumer>
      ));
    }
    return fields;
  }

  render() {
    const { classes, section } = this.props;
    const { expanded } = this.state;

    const sectionTitleClass = expanded
      ? classes.sectionTitleOpen
      : classes.sectionTitleClosed;

    return (
      <div className={classes.sectionWrapper}>
        <button
          aria-expanded={expanded}
          title={section.title}
          className={sectionTitleClass}
          onClick={this.handleOnTitleClick}
        >
          <ChevronDownIcon size="16" opacity="1" />
          <span>{section.title}</span>
          <span className="screenReaderText">
            {this.props.intl.formatMessage({
              id: 'KeyInformationSection.navigationHint',
              defaultMessage: 'Use Tab key to navigate fields',
              description: 'Accessibility hint for keyboard navigation',
            })}
          </span>
        </button>
        {expanded ? (
          <div className={classes.sectionContent} role="menu">
            {this.renderSectionFields()}
          </div>
        ) : null}
      </div>
    );
  }
}

export default injectSheet(styles)(
  injectIntl(withFlags(KeyInformationSection)),
);
